import { View } from "react-native-web";
import { CImage } from "../../../components/atoms";
import { Constants, Images } from "../../../config";

export const castleFilterCriteria = (isMobileVersion, styles) => {
  return [
    {
      title: "Location",
      isHide: isMobileVersion,
      isLocation: true,
    },
    {
      id: Constants.tagCategory.TAG_CATEGORY_STATUS,
      icon: Images.iconTagStatus,
      width: 20,
      height: 20,
      title: "Status",
      isHide: true,
      detailList: [
        {
          id: 1,
          label: "Open",
          tagId: 1,
        },
        {
          id: 2,
          label: "Closed",
          tagId: 2,
        },
        {
          id: 3,
          label: "Temporarily Closed",
          tagId: 4,
        },
        {
          id: 4,
          label: "Permanently Closed",
          tagId: 3,
        },
      ],
      selectedList: [],
    },
    {
      id: Constants.tagCategory.TAG_CATEGORY_AREA,
      icon: Images.iconTagArea,
      width: 20,
      height: 20,
      title: "Area",
      isHide: false,
      detailList: [
        {
          id: 1,
          label: "City",
          tagId: 901,
        },
        {
          id: 2,
          label: "Town",
          tagId: 902,
        },
        {
          id: 3,
          label: "Countryside",
          tagId: 903,
        },
        {
          id: 4,
          label: "Field",
          tagId: 904,
        },
        {
          id: 5,
          label: "Forest",
          tagId: 905,
        },
        {
          id: 6,
          label: "Lake",
          tagId: 906,
        },
        {
          id: 7,
          label: "Beach",
          tagId: 907,
        },
        {
          id: 8,
          label: "Mountain",
          tagId: 908,
        },
        {
          id: 9,
          label: "Unique Location",
          tagId: 911,
        },
        {
          id: 10,
          label: "Other",
          tagId: 913,
        },
      ],
      selectedList: [],
    },
    {
      id: Constants.tagCategory.TAG_CATEGORY_AMENITIES,
      icon: Images.iconTagFeature,
      width: 20,
      height: 20,
      title: "Features",
      isHide: false,
      detailList: [
        {
          id: 1,
          label: "Guided Visit",
          tagId: 53,
        },
        {
          id: 2,
          label: "Museum",
          tagId: 54,
        },
        {
          id: 3,
          label: "Restaurant",
          tagId: 55,
        },
        {
          id: 4,
          label: "Bar",
          tagId: 56,
        },
        {
          id: 5,
          label: "Hotel",
          tagId: 57,
        },
        {
          id: 6,
          label: "Wellness",
          tagId: 58,
        },
        {
          id: 7,
          label: "Park",
          tagId: 59,
        },
        {
          id: 8,
          label: "Event Venue",
          tagId: 60,
        },
      ],
      selectedList: [],
    },
    {
      id: Constants.tagCategory.TAG_CATEGORY_CASTLE_SIZE,
      icon: Images.iconTagSize,
      width: 20,
      height: 20,
      title: "Size",
      isHide: false,
      detailList: [
        {
          id: 1,
          label: "XS",
          tagId: 6301,
        },
        {
          id: 2,
          label: "S",
          tagId: 6302,
        },
        {
          id: 3,
          label: "M",
          tagId: 6303,
        },
        {
          id: 4,
          label: "L",
          tagId: 6304,
        },
        {
          id: 5,
          label: "XL",
          tagId: 6305,
        },
        {
          id: 6,
          label: "XXL",
          tagId: 6306,
        },
      ],
      selectedList: [],
    },
    {
      id: Constants.tagCategory.TAG_CATEGORY_CASTLE_CONDITION,
      icon: Images.iconTagStatus,
      width: 20,
      height: 20,
      title: "Condition",
      isHide: false,
      detailList: [
        {
          id: 1,
          label: "Poor",
          tagId: 6401,
        },
        {
          id: 2,
          label: "Decent",
          tagId: 6402,
        },
        {
          id: 3,
          label: "Good",
          tagId: 6403,
        },
        {
          id: 4,
          label: "Very Good",
          tagId: 6404,
        },
      ],
      selectedList: [],
    },
    {
      id: Constants.tagCategory.TAG_CATEGORY_RATING,
      icon: Images.iconTagRating,
      width: 21.5,
      height: isMobileVersion ? 21 : 20,
      title: "Rating",
      isHide: true,
      isRating: true,
      detailList: [
        {
          id: 1,
          label: "1",
          prefixIcon: (
            <View style={styles.row}>
              <CImage
                source={Images.iconTagRating1}
                width={isMobileVersion ? 16 : 24}
                height={isMobileVersion ? 16 : 24}
                layout="fixed"
              />
            </View>
          ),
        },
        {
          id: 2,
          label: "2",
          prefixIcon: (
            <View style={styles.row}>
              <CImage
                source={Images.iconTagRating2}
                width={isMobileVersion ? 16 : 24}
                height={isMobileVersion ? 16 : 24}
                layout="fixed"
              />
            </View>
          ),
        },
        {
          id: 3,
          label: "3",
          prefixIcon: (
            <View style={styles.row}>
              <CImage
                source={Images.iconTagRating3}
                width={isMobileVersion ? 16 : 24}
                height={isMobileVersion ? 16 : 24}
                layout="fixed"
              />
            </View>
          ),
        },
        {
          id: 4,
          label: "4",
          prefixIcon: (
            <View style={styles.row}>
              <CImage
                source={Images.iconTagRating4}
                width={isMobileVersion ? 16 : 24}
                height={isMobileVersion ? 16 : 24}
                layout="fixed"
              />
            </View>
          ),
        },
        {
          id: 5,
          label: "5",
          prefixIcon: (
            <View style={styles.row}>
              <CImage
                source={Images.iconTagRating5}
                width={isMobileVersion ? 16 : 24}
                height={isMobileVersion ? 16 : 24}
                layout="fixed"
              />
            </View>
          ),
        },
      ],
      selectedList: [],
    },
  ];
};
